export default {
  title: 'Voulez-vous vraiment vous déconnecter ?',
  buttons: {
    logout: 'Se déconnecter',
    cancel: 'Annuler',
  },
};
